import CropInsuranceJSON from './CropInsurance.json';
console.log("CropInsurance ABI:", CropInsuranceJSON.abi);
export const CropInsuranceABI = CropInsuranceJSON.abi;